import './style.css'

interface TimeInputProps {
  onChange: Function
  value: string
}

const TimeInput: React.FC<TimeInputProps> =
  ({ onChange, value }) => (
    <input
      className="time-input"
      type='time'
      step='3600'
      onChange={(e) => { onChange(e)}}
      value={value}
    />
  )

export default TimeInput;